/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import CopyrightWeatherby from '../../shared/copyright/CopyrightWeatherby';

const BestProgeny = (props) => {
    const {
        data: {
            data,
        },
    } = props;

    if (!data ||
        !data.bestProgenyHTMLflat ||
        (Array.isArray(data.bestProgenyHTMLflat) && !data.bestProgenyHTMLflat.length)) {
        return (
            <section
                className="hp-bestProgeny__container--text-center"
            >
                No progeny information for this sire is available

                <CopyrightWeatherby />
            </section>
        );
    }

    const { bestProgenyHTMLflat } = data;

    return (
        <div>
            <section
                className="hp-bestProgeny__container"
                dangerouslySetInnerHTML={{ __html: bestProgenyHTMLflat }}
            />

            <CopyrightWeatherby />
        </div>
    );
};

BestProgeny.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.shape({
            bestProgenyHTMLflat: PropTypes.string,
        }),
    }),
};

export default BestProgeny;



// WEBPACK FOOTER //
// ./src/js/horse/bestProgeny/BestProgeny.jsx